import { c as _c } from "react/compiler-runtime";
const LoadingTopbar = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-screen fixed top-0 left-0 z-50"><div className="h-1 w-full bg-accent overflow-hidden"><div className="animate-progress w-full h-full bg-primary origin-left-right" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export { LoadingTopbar };